var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1573_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0.272284C8.38704 0.271048 5.85895 1.20001 3.86847 2.89283C1.87798 4.58564 0.555106 6.93174 0.136726 9.51101C-0.281654 12.0903 0.23179 14.7342 1.58511 16.9694C2.93844 19.2047 5.04325 20.8851 7.52264 21.7099C8.07264 21.8117 8.27476 21.4707 8.27476 21.1805C8.27476 20.9179 8.26376 20.0517 8.25964 19.1332C5.19889 19.7987 4.55401 17.8352 4.55401 17.8352C4.05351 16.5633 3.33301 16.225 3.33301 16.225C2.33476 15.5417 3.40864 15.5568 3.40864 15.5568C4.51276 15.6338 5.09439 16.6898 5.09439 16.6898C6.07614 18.3714 7.66839 17.8847 8.29539 17.6042C8.39439 16.8933 8.67901 16.4079 8.99389 16.1329C6.55051 15.8552 3.98201 14.9119 3.98201 10.6962C3.98201 9.49578 4.41239 8.51404 5.11501 7.74403C5.00089 7.46628 4.62414 6.34841 5.22089 4.83316C5.22089 4.83316 6.14489 4.53753 8.24726 5.96066C9.14453 5.71658 10.0701 5.59221 11 5.59078C11.935 5.59491 12.8769 5.71728 13.7555 5.96066C15.8551 4.53753 16.7778 4.83316 16.7778 4.83316C17.3759 6.34841 17.0005 7.46766 16.8864 7.74403C17.5918 8.51404 18.018 9.49578 18.018 10.6962C18.018 14.9215 15.444 15.851 12.9951 16.1233C13.3898 16.4643 13.7418 17.1339 13.7418 18.1597C13.7418 19.6309 13.7294 20.8162 13.7294 21.1778C13.7294 21.4707 13.9274 21.813 14.4856 21.7058C16.9646 20.8801 19.0686 19.1989 20.4211 16.9633C21.7735 14.7277 22.286 12.0837 21.8669 9.50475C21.4477 6.92576 20.1241 4.58019 18.1333 2.88804C16.1424 1.19588 13.6142 0.267645 11.0014 0.269534L11 0.272284Z",
    fill: "#0089E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1573_254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.defec458aed6acdc8a1f80ec2930fd12.svg";
export { ForwardRef as ReactComponent };